import { Link } from "react-router-dom";
import { usePermission } from "@/auth/usePermission";
import { PageBanner } from "@/shared/components/PageBanner";

export function QualityHomePage() {
  const canManage = usePermission("quality.manage");

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0" }}>
      <PageBanner
        title="پیش‌خوان کنترل کیفیت (Quality)"
        subtitle="مدیریت برنامه‌های کنترل کیفیت، چک‌لیست‌های بازرسی و ثبت سوابق ارزیابی کالا"
        icon="🛡️"
       helpLink="/help/quality/quality-home" />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "1.5rem",
        }}
      >
        <Link
          to="/quality/families"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            📋
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            خانواده‌های چک‌لیست کیفیت
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            مشاهده و {canManage ? "مدیریت/ایجاد" : ""} تعاریف و نسخه‌های استانداردهای بازرسی کیفیت
          </p>
        </Link>

        <Link
          to="/quality/inspections"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            🔍
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            سوابق بازرسی‌های کیفیت
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            مشاهده سوابق ارزیابی‌ها و {canManage ? "ثبت نتایج بازرسی جدید" : "مشاهده فرم‌ها"}
          </p>
        </Link>
      </div>
    </div>
  );
}
